/**
 * @Author maogangfeng
 * @Date 2020-03-19 14:26:13
 * @Desc 预警管理接口
 */
import http from './instance'

export default {
  /**
   * @Author maogangfeng
   * @Date 2020-03-19 14:27:28
   * @Desc 分页查询实时预警事件
   */
  getProcessingEvents(params) {
    return http.post(`/alert/event/page/processing`, params)
  },
  /**
   * @Author maogangfeng
   * @Date 2020-03-19 14:27:32
   * @Desc 分页查询历史预警事件
   */
  getProcessedEvent(params) {
    return http.post(`/alert/event/page/processed`, params)
  },
  /**
   * @Author maogangfeng
   * @Date 2020-03-19 14:27:35
   * @Desc 查看预警事件详情
   */
  getWarningEventDetail(params) {
    return http.get(`/alert/event/detail`, { params })
  },
  /**
   * @Author maogangfeng
   * @Date 2020-03-19 14:27:38
   * @Desc 实时抓图
   */
  getCaptureImage(params) {
    return http.post(`/alert/event/capture/image`, params)
  },
  /**
   * @Author maogangfeng
   * @Date 2020-03-19 14:27:40
   * @Desc 预警审核
   */
  dealWarningEvent(params) {
    return http.post(`/alert/event/approval`, params)
  },
  /** 获取预警类型列表 */
  emmsAlertLevelConfigAlertTypeList() {
    return http.get(`/alertLevelConfig/alertTypeList`)
  }
}
